import React from "react"
import Img from "gatsby-image"
import { Link } from "../components/localizedlink"
import useNews from "../utility/useNews"
import { FormattedMessage } from "react-intl"


const LinkWrapper = ({ link, title, children }) => {
  if (!link) return children;
  return (
    <a href={link} title={title} target="_blank" rel="noopener noreferrer" className="news__logo text-center">
      {children}
    </a>
  );
}


const RassegnaStampa = ({ featured = false }) => {
  const news = useNews(featured);

  return (
    <section id="news" className="section text-center news clearfix" aria-labelledby="region-news">
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-md-8 col-md-offset-2">
            <h1 id="region-news" className="section__title" data-aos="fade-up">
              <FormattedMessage id="parlano-di-noi" />
            </h1>
            <div className="row" data-aos="fade-up">
              {news.map((item, i) => (
                <React.Fragment key={i}>
                  <div className="col-xs-6 col-sm-4">
                    <div className="news__box">
                      <div className="news__wrapper">
                        <LinkWrapper link={item.link} title={item.name}>
                          <Img fluid={item.fluid} alt={item.name} className="news__img" />
                        </LinkWrapper>
                      </div>
                    </div>
                  </div>
                  {(i + 1) % 2 === 0 && <div className="clearfix visible-xs-block"></div>}
                  {(i + 1) % 3 === 0 && <div className="clearfix visible-sm-block visible-md-block visible-lg-block"></div>}
                </React.Fragment>
              ))}
            </div>
            {featured && (
              <div className="row" data-aos="fade-up">
                <div className="col-xs-12">
                  <Link to="/rassegna-stampa/" alt="Rassegna stampa">
                    <FormattedMessage id="vedi-rassegna-stampa" />
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default RassegnaStampa;